/*
**************************** 
홈페이지 메인
*****************************
*/

import React from "react";

const main = {
    backgroundImage: "url(../../img/slide.jpg)",
    with: "708px",
    height: "965px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}

export default function MainContent() {

    return (
        <div >
            <main className="main" style={main}>
                <div className="">
                    <h1 className="text-white"> <strong>우리집 첫 대형 <br id="hidden-pc" />스마트 홈스쿨의 시작,</strong></h1>
                    <div className="mt-5 text-white fw-bold fs-5">
                        <div><span className="">커다란 화면</span>만큼 <span className="">방대한 컨텐츠</span>로 </div>
                        <div className="mt-3">엘포박스는 아이에게 세상에 대한 <span className="">호기심과 탐구력을 키워 줄 창문</span>이 되어줍니다.</div>
                    </div>
                </div>
            </main>
        </div>
    )
}